const Notfound = () => {
  return (
    <>
      <div>Not Found</div>
    </>
  );
};

export default Notfound;
